import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <CardsSection />
        <FeaturesSection />
        <IndexSection />
        <ContactSection />
        <FaqSection />
        <MediaSection />
        <AboutSection />
        <CommentsSection />
        <UpdatesSection />
        <AppSection />
        <TopicsSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}